import { UI_THEME_DEFAULT, normalizeTheme } from './types'

/**
 * @typedef {object} UiThemeModule
 * @property {import('./types').UiThemeId} id
 * @property {import('vue').Component} Layout
 * @property {Record<string, import('vue').Component>} [views]
 */

/** @type {Record<import('./types').UiThemeId, () => Promise<{ default: UiThemeModule }>>} */
const themeLoaders = {
  default: () => import('./default/index.js'),
  new: () => import('./new/index.js'),
}

/**
 * Dynamically load a theme module. Only the requested theme chunk is fetched.
 *
 * @param {unknown} themeId
 * @returns {Promise<UiThemeModule>}
 */
export async function loadThemeModule(themeId) {
  const id = normalizeTheme(themeId)
  const loader = themeLoaders[id] ?? themeLoaders[UI_THEME_DEFAULT]
  const mod = await loader()
  return mod.default
}
